import PropTypes from 'prop-types';
import React from 'react';
import classnames from "classnames";
import Col from 'react-bootstrap/lib/Col';
import Row from 'react-bootstrap/lib/Row';

import Order from '../../../records/Order';
import t from '../../../lib/I18n';

import Price from '../../general/Price';
import PaymentCardDetails from '../../payment/PaymentCardDetails';
import PaypalPaymentDetails from '../../payment/PaypalPaymentDetails';

const RefundInformation = ({ refund, isFullRefund }) => {
    if (!(refund && (refund.hasRefunds() || refund.isChangeoverRefund))) {
        return null;
    }

    const cards = refund.payments.getCards();
    const voucherAmount = refund.getVoucherRefundAmount();
    const paypalPayment = refund.getPaypalPayment();
    const alternativePayment = refund.getAlternativePayment();
    const cardsFiltered = cards && cards.filter((card) => card.amountRefunded > 0);
    const hasRefundedCardPayment = refund.hasCardPayment() && cardsFiltered && cardsFiltered.size > 0;

    let paymentDetailsClassName = classnames('text-weight--bold', {
        'padding-top--sm': !isFullRefund,
    });

    return (
        <Row>
            <Col xs={ 12 }>
                <div className="padding-bottom--sm border--bottom">
                    <Row>
                        <Col xs={ 12 }>
                            <h3 className={ paymentDetailsClassName }>
                                {t('account.orders.refundDetails')}
                            </h3>
                        </Col>
                    </Row>
                    <Row>
                        {!alternativePayment &&
                            <div>
                                {voucherAmount > 0 && (
                                    <div>
                                        <Col xs={ 8 }>
                                            {t('account.orders.eVoucherPayment', {
                                                count: refund.payments.warrants.size
                                            })}
                                        </Col>
                                        <Col xs={ 4 } className="text-right price">
                                            <Price price={ voucherAmount } />
                                        </Col>
                                    </div>
                                )}

                                {hasRefundedCardPayment &&
                                    <div>
                                        <Col xs={ 8 }>
                                            <PaymentCardDetails card={ cardsFiltered.get(0) } />
                                        </Col>
                                        <Col
                                            xs={ 4 }
                                            className="text-right price"
                                        >
                                            <Price
                                                price={ cards.map(entry => entry.get('amountRefunded')).reduce((prev, current) => prev + current) }
                                            />
                                        </Col>
                                    </div>
                                }

                                {paypalPayment && (
                                    <div>
                                        <Col xs={ 8 }>
                                            <PaypalPaymentDetails
                                                payment={ paypalPayment }
                                            />
                                        </Col>
                                        <Col xs={ 4 } className="text-right price">
                                            <Price
                                                price={ paypalPayment.amountRefunded }
                                            />
                                        </Col>
                                    </div>
                                )}
                            </div>
                        }
                        {alternativePayment && (
                            <div>
                                <Col xs={ 8 }>
                                    { t(`account.orders.refund.itso.manualRefundedIn.${refund.getAlternativePaymentType()}`) }
                                </Col>
                                <Col xs={ 4 } className="text-right price">
                                    <Price
                                        price={ alternativePayment.amount }
                                    />
                                </Col>
                            </div>
                        )}
                    </Row>
                </div>
            </Col>
        </Row>
    );
};

RefundInformation.propTypes = {
    refund: PropTypes.instanceOf(Order),
    isFullRefund: PropTypes.bool
};

export default RefundInformation;
